import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OwnerDetailRoutingModule } from './owner-detail-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    OwnerDetailRoutingModule,
  ]
})
export class OwnerDetailModule { }
